export const STATUS = {
  APPROVED: 'APPROVED'
};
export const SLOTS = {
  AM: 'AM',
  PM: 'PM',
  FULL: 'FULL'
};

export const SITES = [
  { id: 'EMPLAS_1', name: 'EMPLAS 1' },
  { id: 'EMPLAS_2', name: 'EMPLAS 2' }
];

export const SLOT_TYPES = [
  { id: SLOTS.AM, label: 'Half-day (Morning)' },
  { id: SLOTS.PM, label: 'Half-day (Afternoon)' },
  { id: SLOTS.FULL, label: 'Full day' }
];

export const MAX_WEKKLY_REQUEST = 2;
export const WEEK_AHEAD_COUNT = 4;
